import { ChartColumnIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type EmptyChartProps = {
	title?: string;
	subtitle?: string;
};
export function EmptyChart({ title, subtitle }: EmptyChartProps) {
	const { t } = useTranslation();
	return (
		<div className="h-full flex items-center justify-center p-6">
			<div className="text-center">
				<ChartColumnIcon className="size-16 text-muted-foreground mx-auto mb-3" />
				<p className="text-muted-foreground font-medium">{title || t('health.empty.selectPrompt')}</p>
				<p className="text-sm text-muted-foreground mt-1">{subtitle || t('health.empty.selectSubtitle')}</p>
			</div>
		</div>
	);
}
